import { SessionParticipant } from "@classview/shared-types";

/**
 * Returns the participant ID for a given participant.
 * If the participant is a room system, the participantId is '0'.
 * If the participant is a user, the participantId is the userId without the "Guest_" prefix.
 * @param userId
 * @returns
 */
export function getParticipantId(userId: string) {
  if (isRoomSystem(userId)) {
    return "0";
  }
  return userId.replace("Guest_", "");
}

/**
 * Returns the entity ID for a given participant.
 * If the participant is a room system, the entityId is the userId without the "User_" prefix.
 * If the participant is a user, the entityId is '0'.
 * @param participant
 * @returns
 */
export function getEntityId(userId: string) {
  if (isRoomSystem(userId)) {
    return userId.replace("User_", "");
  }
  return "0";
}

/**
 * Returns true if the participant is a room system.
 * @param participant
 * @returns
 */
export function isRoomSystem(user: string | SessionParticipant): boolean {
  if (typeof user === "string") {
    return user.startsWith("User_");
  }
  return user.entityId !== "0";
}
